import { render } from "./TrinketGridPoint.vue?vue&type=template&id=9e00e910&scoped=true&ts=true"
import script from "./TrinketGridPoint.vue?vue&type=script&lang=ts"
export * from "./TrinketGridPoint.vue?vue&type=script&lang=ts"

import "./TrinketGridPoint.vue?vue&type=style&index=0&id=9e00e910&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e00e910"]])

export default __exports__